import { graphql } from 'gatsby'
import { JsonLd } from 'react-schemaorg'
import { IndividualProduct } from 'schema-dts'

import Layout from '../../../components/layout'
import Seo from '../../../components/seo'
import Benefits from '../../../components/Benefits'
import InfoBoxes from '../../../components/InfoBoxes'
import { TrustPilotSmall } from '../../../components/TrustPilot/Trustbox'

import generateWatchProjectImage from '../../../utils/generateWatchProjectImage'
import MagazineArticle from '../../../components/MagazineArticle'
import SeoWatchHeader from '../../../components/PDP/SeoWatchHeader'

interface BuyingPageProps {
  data: {
    seoWatch: WatchProject21Api.SeoWatch
  }
}

type MagazineArticleProps = Pick<WatchProject21Api.Magazine, 'title' | 'createdAt' | 'topText' | 'topAltText' | 'topImage' | 'bottomText' | 'bottomAltText' | 'bottomImage'>;

const VirtualProductBuyingPage = ({ data }: BuyingPageProps) => {
  const { seoWatch } = data;
  const { watch } = seoWatch;

  const magazine: MagazineArticleProps = {
    title: `${watch.brand?.name || ''} ${watch.model?.name || ''}`,
    createdAt: seoWatch.createdAt,
    topText: seoWatch.topText,
    topAltText: seoWatch.topAltText,
    topImage: seoWatch.topImage,
    bottomText: seoWatch.bottomText,
    bottomAltText: seoWatch.bottomAltText,
    bottomImage: seoWatch.bottomImage,
  }

  return (
    <Layout bgColor='bg-white' footerColor='bg-gray' hasStickyChildren>
      <Seo title={`${watch.brand?.name || ''} ${watch.model?.name || ''} ${watch.referenceNumber || ''}`} />
      <JsonLd<IndividualProduct>
        item={{
          '@context': 'https://schema.org',
          '@type': 'IndividualProduct',
          name: `${watch.brand?.name || ''} ${watch.model?.name || ''} ${watch.referenceNumber || ''}`,
          image: generateWatchProjectImage(seoWatch.imagePath, watch.referenceNumber),
          brand: watch.brand?.name,
          model: watch.model?.name,
          sku: watch.referenceNumber,
          description: seoWatch.description,
          offers: {
            '@type': 'Offer',
            price: seoWatch.price,
            priceCurrency: 'EUR',
            availability: 'https://schema.org/InStock',
            url: `https://www.watchproject21.com/comprar/productos/${seoWatch.watch__slug}`,
          },
        }}
      />
      <SeoWatchHeader seoWatch={seoWatch} />
      <InfoBoxes />
      <MagazineArticle magazine={magazine} topComponent={null} />
      <Benefits />
      <TrustPilotSmall />
    </Layout>
  )
}

export default VirtualProductBuyingPage

export async function config() {
  return () => ({
    defer: true,
  })
}

export const query = graphql`
  query($language: String!, $slug: String!) {
    seoWatch: seoWatch(slug: {eq: $slug }) {
      seoWatchId
      imagePath
      gender
      description
      location
      movement
      price
      priceOnDemand
      boxMaterial
      wristbandMaterial
      productionYear
      watchCondition
      gender
      diameter
      additionalTitle
      metaTitle
      metaDescription
      topText
      topAltText
      topImage
      bottomText
      bottomAltText
      bottomImage
      watch {
        referenceNumber
        slug
        model {
          name
        }
        brand {
          name
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

